import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'antd';
import '../../../styles/savers/custom.css';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ArrowRightOutlined } from '@ant-design/icons';

import { exportSaversDataToExcel } from '@/utils/excel';

import { setLocationRequestId } from '../../../redux/Savers/SaversActions';
import { getAllLocationsEffect } from '../../../redux/Savers/SaversEffects';
import SecondaryLabel from '../../components/Labels/SecondaryLabel';
import ScrollPagination from '../../components/Paginations/ScrollPagination';
import ContentSpinner from '../../components/Spinners/ContentSpinner';
import LocationSearch from '../../screens/Savers/LocationSearch';

export default function Locations({ isModal, toggleTrailerReview }) {
  const [loading, setLoading] = useState(false);
  const [supplyZoneOptions, setSupplyZoneOptions] = useState([]);
  const [IdOptions, setIdOptions] = useState([]);
  const [nameOptions, setNameOptions] = useState([]);
  const [supplyZoneNumberOptions, setSupplyZoneNumberOptions] = useState([]);
  const [errMessage, setErrMessage] = useState('');
  const { selectedCompany } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userRole = useSelector((state) => state.savers.loggedInUser.data);

  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO: Add dependencies* that are required
  useEffect(() => {
    getAllDropDownOptions();
  }, [selectedCompany]);

  const getSupplyZones = async (queryString) => {
    try {
      setLoading(true);
      const { data } = await getAllLocationsEffect(queryString);
      setSupplyZoneOptions(data);
      if (data.length === 0) {
        setErrMessage('Data not found.');
      } else {
        setErrMessage('');
      }
    } catch (error) {
      console.error(error);
      setSupplyZoneOptions([]);
    } finally {
      setLoading(false);
    }
  };

  const getAllDropDownOptions = async () => {
    try {
      setLoading(true);
      const { data } = await getAllLocationsEffect();
      setSupplyZoneOptions(data);
      const options = data.map((row) => ({
        label: row.branchCustRef,
        value: row.branchKey,
      }));

      const optionNames = data.map((row) => ({
        label: row.branchDesc,
        value: row.branchKey,
      }));

      const supplyOptions = [...new Set(data.map((row) => row.locationType).filter(Boolean))].map((locationType) => ({
        label: locationType,
        value: locationType,
      }));

      setIdOptions(options);
      setNameOptions(optionNames);
      setSupplyZoneNumberOptions(supplyOptions);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const searchOnClick = (supplyZoneId, supplyZoneName, zoneRegionName, locationType) => {
    const queryString = createQueryString(supplyZoneId, supplyZoneName, zoneRegionName, locationType);
    getSupplyZones(queryString);
  };

  const createQueryString = (supplyZoneId, supplyZoneName, zoneRegionName, locationType) => {
    const params = [];

    if (supplyZoneId) {
      params.push(`branchKey=${supplyZoneId}`);
    }
    if (supplyZoneName) {
      params.push(`branchDesc=${supplyZoneName}`);
    }
    if (zoneRegionName) {
      params.push(`regionDesc=${zoneRegionName}`);
    }
    if (locationType) {
      params.push(`locationType=${locationType}`);
    }

    return params.length ? `?${params.join('&')}` : '';
  };

  const columnFormatter = () => {
    return (
      <span>
        {' '}
        <Link to="#" className="color-1 cursor-pointer">
          <ArrowRightOutlined />
        </Link>{' '}
      </span>
    );
  };

  const loadTrailerData = (row) => {
    dispatch(setLocationRequestId(row.branchKey));
    if (isModal) {
      toggleTrailerReview();
      return;
    }
    navigate('/Trailer-Database', { state: row });
  };

  const columns = [
    {
      dataField: 'branchKey',
      hidden: true,
      text: 'id',
    },
    {
      align: 'right',
      dataField: 'locationType',
      headerStyle: { textAlign: 'center' },
      text: 'Supply Zone',
    },
    {
      align: 'right',
      dataField: 'branchCustRef',
      headerStyle: { textAlign: 'center' },
      text: 'Location Id',
    },
    {
      align: 'left',
      dataField: 'branchDesc',
      headerStyle: { textAlign: 'center' },
      sort: true,
      text: 'Location Name',
    },
    {
      align: 'left',
      dataField: 'regionDesc',
      headerStyle: { textAlign: 'center' },
      sort: true,
      text: 'Region',
    },
    {
      align: 'center',
      dataField: 'branchKey',
      events: {
        onClick: (_e, _column, _columnIndex, row) => {
          loadTrailerData(row);
        },
      },
      formatter: columnFormatter,
      headerStyle: { textAlign: 'center' },
      text: 'Go to Trailer List per Location',
    },
  ];

  const handleExport = () => {
    const filteredColumns = columns.filter(
      (column) => column.dataField !== 'branchKey' && column.dataField !== 'rscm' && column.dataField !== 'scs',
    );

    exportSaversDataToExcel(supplyZoneOptions, 'Locations_Data', filteredColumns);
  };

  return (
    <>
      {!isModal && (
        <Row gutter={20}>
          <Col sm={24}>
            <span className="pull-right color-1" style={{ marginTop: '-26px', position: 'fixed', right: '32px' }}>
              {' '}
              <strong> {userRole} </strong> Logged In{' '}
            </span>
          </Col>
        </Row>
      )}
      <div className="paper-container h-100 w-100">
        <div className="py-5 px-10">
          <LocationSearch
            isModal={isModal}
            IdOptions={IdOptions}
            locationNames={nameOptions}
            onSearchClick={searchOnClick}
            supplyZoneNumberOptions={supplyZoneNumberOptions}
          />
          {loading ? (
            <div style={{ marginTop: '15%' }}>
              <ContentSpinner size="large" />
            </div>
          ) : (
            <Row gutter={15}>
              <Col sm={24}>
                <div className="savers">
                  {!isModal && (
                    <div className="my-4 mx-1 text-end">
                      <button className="btn btn-dipblue" type="button" onClick={handleExport}>
                        Export to Excel
                      </button>
                    </div>
                  )}
                  <ScrollPagination
                    className="background-white br-4 w-100 h-100 scrollable-table-container horizontal"
                    scrollOffset={50}
                    hideSpinner={false}
                  >
                    <table className="w-100 background-white br-4">
                      <thead className=" ">
                        <tr>
                          {columns.map(
                            ({ text, hidden }) =>
                              !hidden && (
                                <th key={text} className="background-header text-white fixed fixed-top fixed-left">
                                  {text}
                                </th>
                              ),
                          )}
                        </tr>
                      </thead>
                      <tbody className="custom-scroll-bar">
                        {supplyZoneOptions.length === 0 ? (
                          <tr>
                            <td colSpan={columns.length} style={{ color: 'red', textAlign: 'center' }}>
                              {errMessage}
                            </td>
                          </tr>
                        ) : (
                          supplyZoneOptions.map((row) => (
                            <tr key={row.branchKey}>
                              <GenerateColumnValues row={row} columns={columns} />
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </ScrollPagination>
                </div>
              </Col>
            </Row>
          )}
        </div>
      </div>
    </>
  );
}
const GenerateColumnValues = ({ row, columns }) => {
  return (
    <>
      {columns.map(
        ({ dataField, formatter, hidden, align, events }) =>
          !hidden && (
            <td key={dataField} className={`text-${align || 'left'}`}>
              <SecondaryLabel className="f-15 fw-600 text-black">
                {events?.onClick ? (
                  <Link to="#" onClick={(e) => events.onClick(e, null, null, row, null)}>
                    {formatter ? formatter(row[dataField], row) : row[dataField]}
                  </Link>
                ) : formatter ? (
                  formatter(row[dataField], row)
                ) : (
                  row[dataField]
                )}
              </SecondaryLabel>
            </td>
          ),
      )}
    </>
  );
};
